/**
 * E.164 shape: a leading `+` and 8–17 digits where the first digit is
 * non-zero. Matches what the backend stores for `forwardingPhoneNumber`
 * and what Telnyx accepts as a `to` parameter for `createCall`.
 */
export const E164_RE = /^\+[1-9]\d{7,16}$/;

/**
 * `RedoPhoneNumberInput` formats its value with the country mask (e.g.
 * `"+1 (555) 555-0123"`). Strip everything except digits, prefix with
 * `+`, and return the resulting E.164 candidate. Empty input returns
 * an empty string. Validate the result with {@link E164_RE} before
 * sending it to the backend — the regex accepts E.164 only.
 */
export function normalizeMaskedPhone(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed === "") {
    return "";
  }
  const digits = trimmed.replace(/[^\d]/g, "");
  if (digits === "") {
    return "";
  }
  return `+${digits}`;
}
